




















































































































































import {Component, Vue} from 'vue-property-decorator';
import VueElementLoading from 'vue-element-loading';
import store from "@/services/store";
import PowerBiBTab from "@/components/c-power-bi-iframe/BTab.vue";
import PowerBiIframe from "@/components/c-power-bi-iframe/Iframe.vue";
import regionBudget from '@/modules/budget-execution-analytics/regionBudget.vue'


@Component({
    components: {
        'loading': VueElementLoading,
        'PowerBiBTab': PowerBiBTab,
        'PowerBiIframe': PowerBiIframe,
        'region-budget': regionBudget
    }
})
export default class PurchasePlan extends Vue {
    private region = '00';

    private visible = true

    setVisible(vis: boolean) {
        this.visible = vis
    }

    mounted() {
        this.loadFrames();
        this.region = store.state._instanceCode;
    }

    private frames_list: any[] = []

    private async loadFrames() {
        const response = await fetch('/api-py/get-power-bi-frames-list/005.008');
        if (response.status == 200) {
            const result = await response.json() as Array<any>;
            this.frames_list = result.filter(value => value.region_instance_code == this.region)
        }
    }


}
